import { render, staticRenderFns } from "./BlockOverlay.vue?vue&type=template&id=0387b771&scoped=true&"
import script from "./BlockOverlay.vue?vue&type=script&lang=js&"
export * from "./BlockOverlay.vue?vue&type=script&lang=js&"
import style0 from "./BlockOverlay.vue?vue&type=style&index=0&id=0387b771&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0387b771",
  null
  
)

export default component.exports